import { render, staticRenderFns } from "./DeleteAnnotationsModal.vue?vue&type=template&id=637e00a0&scoped=true"
import script from "./DeleteAnnotationsModal.vue?vue&type=script&lang=js"
export * from "./DeleteAnnotationsModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteAnnotationsModal.vue?vue&type=style&index=0&id=637e00a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637e00a0",
  null
  
)

export default component.exports